import { Modifier } from '@dnd-kit/core';

/** Keeps the dragged item on the list's vertical axis: no sideways (free) positioning. */
export const restrictToVerticalAxis: Modifier = ({ transform }) => ({
  ...transform,
  x: 0,
});
